/**
 * The basket uid, generated first when the customer does not have one yet. Every write that stores something on the
 * basket has to go through this - the uid identifies the basket, so asking for it afterwards would store the data on a
 * basket nobody is looking at.
 */
export const ensureBasketUid = async (): Promise<string> => {
    const uidCookie = useUidCookie()
    if (uidCookie.value) {
        return uidCookie.value
    }

    const uid = await useNuxtApp().$repository.generateBasketUid(useAccessTokenCookie().value || '')
    uidCookie.value = uid

    return uid
}
